import { motion } from "framer-motion";
import { WHY, fadeUp } from "./content";

export default function WhyUs() {
  return (
    <section id="why" className="py-24 md:py-32 bg-surface-alt border-y border-[#dedcd2]" data-testid="why-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          className="max-w-3xl mb-16"
        >
          <span className="overline text-ink-soft">Why Wellknowe</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-forest">
            One trusted clinician. Three flexible services.
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          transition={{ staggerChildren: 0.1 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {WHY.map((w, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              custom={i}
              className="rounded-[8px] border border-[#d6d4c9] bg-bone p-8"
              data-testid={`why-stat-${i}`}
            >
              <div className="font-display text-4xl md:text-5xl tracking-tight text-forest">
                {w.stat}
              </div>
              <p className="mt-4 text-sm md:text-base text-ink-soft leading-relaxed">{w.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
